module.exports = __webpack_public_path__ + "assets/img/fangan04.a4663518.png";